var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",style:({ width: _vm.bSizeRem + 'rem',height: _vm.bSizeRem + 'rem'})},[_c('div',{staticClass:"chart",style:({ width: _vm.bSizeRem + 'rem',height: _vm.bSizeRem + 'rem'}),attrs:{"id":"chart"+_vm.BallIndex}})])}
var staticRenderFns = []

export { render, staticRenderFns }